module.exports = __webpack_public_path__ + "img/success.bd687127.png";